import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const ContactoComercial = ({ datos, setDatos, errores }) => {
    const [puntosVenta, setPuntosVenta] = useState(datos.puntos_venta.length > 0 ? datos.puntos_venta : [
        {
            calle: '',
            numero_ext: '',
            numero_int: '',
            localidad: '',
            municipio: '',
            codigo_postal: '',
            estado: '',
            telefono: '',
            whatsapp: '',
            email: ''
        }
    ]);

    useEffect(() => {
        setDatos({ target: { value: puntosVenta, name: 'puntos_venta' } });
    }, [puntosVenta]);
    const handleAddPunto = () => {
        setPuntosVenta([...puntosVenta, {
            calle: '',
            numero_ext: '',
            numero_int: '',
            localidad: '',
            municipio: '',
            codigo_postal: '',
            estado: '',
            telefono: '',
            whatsapp: '',
            email: ''
        }]);
    };
    const handleChangePunto = (value, label, index) => {
        setPuntosVenta((prevPuntos) => {
            // Crear una nueva copia del array productosServicios
            const nuevosPuntos = [...prevPuntos];
            // Crear una copia del producto actualizado
            const newPunto = { ...nuevosPuntos[index] };
            // Actualizar la propiedad del producto
            newPunto[label] = value;
            nuevosPuntos[index] = newPunto;
            return nuevosPuntos;
        });
    };
    return (
        <Box sx={{ mb: { xs: 10, lg: 0 } }}>
            <Typography sx={{ my: 2 }} variant="h6">Contacto comercial</Typography>
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} lg={12}>
                    <TextField fullWidth required label="Nombre del contacto"
                        name='nombre_contacto'
                        value={datos.nombre_contacto}
                        onChange={setDatos} />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <TextField required
                        fullWidth
                        label={`Calle`}
                        variant="outlined"
                        value={datos.calle}
                        onChange={setDatos}
                        name='calle'
                    />
                </Grid>
                <Grid item xs={6} lg={2}>
                    <TextField required
                        fullWidth
                        label={`Número exterior`}
                        variant="outlined"
                        inputProps={{ maxLength: 10 }}
                        value={datos.numero_ext}
                        onChange={setDatos}
                        name='numero_ext'
                    />
                </Grid>
                <Grid item xs={6} lg={2}>
                    <TextField
                        fullWidth
                        label={`Número interior`}
                        variant="outlined"
                        inputProps={{ maxLength: 10 }}
                        value={datos.numero_int}
                        onChange={setDatos}
                        name='numero_int'
                    />
                </Grid>
                <Grid item xs={12} lg={2}>
                    <TextField required
                        fullWidth
                        name='codigo_postal'
                        label={`Código Postal`}
                        inputProps={{ maxLength: 10 }}
                        variant="outlined"
                        type="number"
                        value={datos.codigo_postal}
                        onChange={setDatos}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <TextField required
                        fullWidth
                        label={`Localidad`}
                        variant="outlined"
                        onChange={setDatos}
                        value={datos.localidad}
                        name='localidad'
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <TextField required
                        fullWidth
                        label={`Municipio`}
                        variant="outlined"
                        onChange={setDatos}
                        value={datos.municipio}
                        name='municipio'
                    />
                </Grid>

                <Grid item xs={12} lg={4}>
                    <TextField required
                        fullWidth
                        label={`Estado`}
                        variant="outlined"
                        onChange={setDatos}
                        value={datos.estado}
                        name='estado'
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <TextField required
                        fullWidth
                        label={`Teléfono`}
                        variant="outlined"
                        onChange={setDatos}
                        value={datos.telefono}
                        inputProps={{ maxLength: 10 }}
                        name='telefono'
                        type="number"
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <TextField
                        fullWidth
                        label={`WhatsApp`}
                        variant="outlined"
                        name='whatsapp'
                        type="number"
                        inputProps={{ maxLength: 10 }}
                        onChange={setDatos}
                        value={datos.whatsapp}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <TextField required
                        fullWidth
                        name='email'
                        label={`Correo electrónico`}
                        variant="outlined"
                        onChange={setDatos}
                        value={datos.email}
                    />
                </Grid>
            </Grid>

            <Divider />
            <Typography sx={{ my: 2 }} variant="h6">Puntos de Venta y/o Distribuidores</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                {puntosVenta.map((punto, index) => (
                    <Box key={index} marginBottom={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={12}>
                                <Typography sx={{ my: 2, fontWeight: 'bold' }}>Punto de Venta y/o Distribuidor {index + 1}</Typography>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <TextField required
                                    fullWidth
                                    label={`Calle`}
                                    variant="outlined"
                                    value={punto.calle}
                                    onChange={(e) => handleChangePunto(e.target.value, 'calle', index)}
                                />
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <TextField required
                                    fullWidth
                                    label={`Número exterior`}
                                    inputProps={{ maxLength: 10 }}
                                    variant="outlined"
                                    value={punto.numero_ext}
                                    onChange={(e) => handleChangePunto(e.target.value, 'numero_ext', index)}
                                />
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <TextField
                                    fullWidth
                                    label={`Número interior`}
                                    inputProps={{ maxLength: 10 }}
                                    variant="outlined"
                                    value={punto.numero_int}
                                    onChange={(e) => handleChangePunto(e.target.value, 'numero_int', index)}
                                />
                            </Grid>
                            <Grid item xs={12} lg={2}>
                                <TextField required
                                    fullWidth
                                    label={`Código Postal`}
                                    inputProps={{ maxLength: 10 }}
                                    variant="outlined"
                                    type="number"
                                    value={punto.codigo_postal}
                                    onChange={(e) => handleChangePunto(e.target.value, 'codigo_postal', index)}
                                />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <TextField required
                                    fullWidth
                                    label={`Localidad`}
                                    variant="outlined"
                                    value={punto.localidad}
                                    onChange={(e) => handleChangePunto(e.target.value, 'localidad', index)}
                                />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <TextField required
                                    fullWidth
                                    label={`Municipio`}
                                    variant="outlined"
                                    value={punto.municipio}
                                    onChange={(e) => handleChangePunto(e.target.value, 'municipio', index)}
                                />
                            </Grid>

                            <Grid item xs={12} lg={4}>
                                <TextField required
                                    fullWidth
                                    label={`Estado`}
                                    variant="outlined"
                                    value={punto.estado}
                                    onChange={(e) => handleChangePunto(e.target.value, 'estado', index)}
                                />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <TextField required
                                    fullWidth
                                    label={`Teléfono`}
                                    variant="outlined"
                                    value={punto.telefono}
                                    type="number"
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => handleChangePunto(e.target.value, 'telefono', index)}
                                />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <TextField
                                    fullWidth
                                    label={`WhatsApp`}
                                    variant="outlined"
                                    type="number"
                                    value={punto.whatsapp}
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => handleChangePunto(e.target.value, 'whatsapp', index)}
                                />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <TextField required
                                    fullWidth
                                    label={`Correo electrónico`}
                                    variant="outlined"
                                    value={punto.email}
                                    onChange={(e) => handleChangePunto(e.target.value, 'email', index)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                ))}
            </Box>
            <Button sx={{ mb: 2 }} variant="contained" color="primary" onClick={handleAddPunto}>
                Agregar
            </Button>

        </Box>
    )
}

export default ContactoComercial